<template>
  <svg
    width="221"
    height="239"
    viewBox="0 0 221 239"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="6.49512" width="220.841" height="215.437" fill="#D3D3D3" />

    <path
      d="M0 218.215L0.000747364 232.014L15.6402 239L31.5494 232.014L47.1889 239L63.098 232.014L78.7375 239L94.6466 232.014L110.286 239L126.195 232.014L141.835 239L157.744 232.014L173.383 239L189.293 232.014L204.932 239L220.841 232.014L220.841 218.215H0Z"
      fill="#D3D3D3"
    />

    <path
      d="M0 20.7852L0.000747364 6.98566L15.6402 0.000108719L31.5494 6.98566L47.1889 0.000108719L63.098 6.98566L78.7375 0.000108719L94.6466 6.98566L110.286 0.000108719L126.195 6.98566L141.835 0.000108719L157.744 6.98566L173.383 0.000108719L189.293 6.98566L204.932 0.000108719L220.841 6.98566L220.841 20.7852H0Z"
      fill="#D3D3D3"
    />

    <path d="M15 38H92" stroke="#5C5C5C" stroke-width="2" />

    <g clip-path="url(#clip0_2825_10247)">
      <path
        d="M110 48.5C115.799 48.5 120.5 43.799 120.5 38C120.5 32.201 115.799 27.5 110 27.5C104.201 27.5 99.5 32.201 99.5 38C99.5 43.799 104.201 48.5 110 48.5Z"
        stroke="#5C5C5C"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M110 30.5V38.55L114.5 41"
        stroke="#5C5C5C"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>

    <path d="M128 38H205" stroke="#5C5C5C" stroke-width="2" />

    <path d="M15 67.5869L204.936 68.079" stroke="#5C5C5C" stroke-width="2" />

    <path d="M15 94.667L204.936 95.159" stroke="#5C5C5C" stroke-width="2" />

    <path d="M15 121.746H131.709" stroke="#5C5C5C" stroke-width="2" />

    <path d="M15 148.333H187.323" stroke="#5C5C5C" stroke-width="2" />

    <path d="M15 174.921L204.936 175.413" stroke="#5C5C5C" stroke-width="2" />

    <path d="M15 202H175.069" stroke="#5C5C5C" stroke-width="2" />

    <defs>
      <clipPath id="clip0_2825_10247">
        <rect width="24" height="24" fill="white" transform="translate(98 26)" />
      </clipPath>
    </defs>
  </svg>
</template>
